import React, { useCallback } from 'react';
import { FormattedMessage } from 'react-intl';

import { InfoBadge } from '@tmapy/style-guide';

import type { GeodesistResponse } from '../../openapi/types';
import { useAppContext, useHistoryAction } from '../../hooks';
import { getCmdCtrlUrl } from '../../utils/getcmdctrlurl';
import { RouteId } from '../../routes';

import { GEODESIST_IS_ACTIVE } from '../constants';
import { useCertification } from './geodesistsHooks';
import { isActiveMessages } from './geodesistMessages';

export const GeodesistListItem: React.FC<GeodesistResponse> = (props) => {
  const { appType } = useAppContext();
  const routeToGeodesistDetail = useHistoryAction('managerGeodesistDetail', { id: props.id });

  const handleClick = useCallback(
    (event: React.MouseEvent) => {
      if (event.ctrlKey || event.metaKey) {
        window.open(
          getCmdCtrlUrl('managerGeodesistDetail' as RouteId, { appType, id: props.id }),
          '_blank',
        );
        return; // Ponech nativní chování
      }
      const selectText = window.getSelection();
      if (!selectText || selectText.toString() === '') {
        routeToGeodesistDetail();
      }
    },
    [routeToGeodesistDetail],
  );

  const certifications = useCertification(
    props.has_certification_a,
    props.has_certification_b,
    props.has_certification_c,
  );

  return (
    <tr onClick={handleClick}>
      <td>{props.official_number}</td>
      <td className='sg-u-type-bold'>
        {props.name} {props.surname}
      </td>
      <td>
        <FormattedMessage
          {...isActiveMessages[
            props.is_active ? GEODESIST_IS_ACTIVE.TRUE : GEODESIST_IS_ACTIVE.FALSE
          ]}
        />
      </td>
      <td>
        {certifications.map((item, idx) => (
          <InfoBadge key={idx}>{item}</InfoBadge>
        ))}
      </td>
      <td>{props.note}</td>
    </tr>
  );
};
